import React from 'react';

import { useTranslations } from 'utils';

import './Notes.scss';

function Notes() {
  const i18n = useTranslations();

  return (
    <div className="Notes">
      <div className="Notes-content">
        <div className="Notes-title">
          {i18n.t('paymentOptions.recurringPayment.notes.title')}
        </div>
        <p className="Notes-description">
          {i18n.t('paymentOptions.recurringPayment.notes.description')}
        </p>
      </div>
    </div>
  );
}

Notes.displayName = 'EURateDisclaimer';

export { Notes };
